export const Colors = {
  WifeVector: 0xFF7171,
  HusbandVector: 0x3971D9,
  CatVector: 0xFEC937,
  LocationVector: 0x181818,

  // used for the bottom of some vectors
  NeutralGrey: 0xC9C9C9,
  LighterGrey: 0xeeeeee,
  WinnerColor: 0xED721F,
  LoserColor: 0x2F7DA0,
  HappyColor: 0xA1C634,
  SadColor: 0x6EC5F5,
  AnxietyColor: 0x725ba3,

  White: 0xfcfdff,
  DarkModeGrey: 0x424347,
  FraunhoferBlack: 0x212227
};
